import type React from "react";
import HeaderSimple from "../components/header-simple";

type Props = {
	children: React.ReactNode;
	showHeader?: boolean;
};
export default function SimpleLayout({ children, showHeader = true }: Props) {
	return (
		<div className="flex h-screen w-full flex-col text-text-base bg-bg">
			{showHeader && <HeaderSimple />}
			{children}
		</div>
	);
}
